import {
  UPDATE_SELECT_COUPON
} from '../mutation-types'

import superagent from 'superagent'
import userInfo from './userInfo'
import { RequestControl, RequestCommonResponse } from '../actions'

const state = {
  select_id: null,
  select_money: null
}

const mutations = {
  [UPDATE_SELECT_COUPON] (state, data) {
    state.select_id = data.vouchers_Identifier
    state.select_money = data.vouchers_money
  }
}

const actions = {
  // 用户优惠卡券
  // type '1'代表优惠卡券页 '2'选择卡券页
  userCoupon ({ commit, rootState }, type) {
    var _params = {
      type: type,
      user_id: userInfo.state.user_id,
      vouchers_type: 8,
      os: '0'
    }
    return new Promise(function (resolve, reject) {
      _params = RequestControl(rootState, _params)
      commit('UPDATE_LOADING', true)
      superagent
      .post('/index.php/users/vouchers/get_my_vouchers')
      .send(_params)
      .type('form')
      .end(function (err, res) {
        commit('UPDATE_LOADING', false)
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  // 用户历史卡券
  userHistoryCoupon ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      commit('UPDATE_LOADING', true)
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/users/vouchers/get_my_vouchers')
      .send(params)
      .type('form')
      .end(function (err, res) {
        commit('UPDATE_LOADING', false)
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  // 重置优惠劵
  resetVoucher ({ commit, rootState }, orderId) {
    var _params = {
      user_id: rootState.userInfo.user_id,
      order_id: orderId
    }
    return new Promise(function (resolve, reject) {
      _params = RequestControl(rootState, _params)
      superagent
      .post('/index.php/charter/mine/reset_voucher')
      .send(_params)
      .type('form')
      .end(function (err, res) {
        commit('UPDATE_LOADING', false)
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  clearSelectCoupon ({ commit }, params) {
    commit('UPDATE_SELECT_COUPON', {
      vouchers_Identifier: null,
      vouchers_money: null
    })
  },
  setSelectCoupon ({ commit }, params) {
    commit('UPDATE_SELECT_COUPON', params)
  }
}

export default {
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/myCoupon.js